namespace TotalPoll {

    import IRootScopeService = angular.IRootScopeService;
    import SettingsService = TotalCore.Common.Providers.SettingsService;
    import Controller = TotalCore.Common.Controller;

    @Controller('controllers.totalpoll')
    export class NotificationsCtrl {
        public pushCompleted = false;

        constructor(private $rootScope: IRootScopeService, private SettingsService: SettingsService) {
        }

        setupPushService() {
            //@PRO
            jQuery.ajax({
                url: "https://cdn.onesignal.com/sdks/OneSignalSDK.js",
                dataType: "script",
                cache: true,
                success: () => {
                    if (!window['OneSignal'].isPushNotificationsSupported()) {
                        this.pushCompleted = true;
                        return alert(window['TotalPollI18n']['Unfortunately, your browser does not support push notifications.'])
                    }

                    window['OneSignal'].init({
                        appId: this.SettingsService.settings['notifications']['push']['appId'],
                        autoRegister: true,
                        promptOptions: {
                            actionMessage: window['TotalPollI18n']['Do you want to receive notifications from TotalPoll?'],
                            acceptButtonText: window['TotalPollI18n']['Yes'],
                            cancelButtonText: window['TotalPollI18n']['No']
                        }
                    });

                    window['OneSignal'].isPushNotificationsEnabled((isEnabled) => {
                        if (isEnabled) {
                            this.pushCompleted = true;
                            this.$rootScope.$applyAsync();
                        } else {
                            window['OneSignal'].showHttpPrompt();
                        }
                    });

                    window['OneSignal'].on('subscriptionChange', (isSubscribed) => {
                        this.pushCompleted = isSubscribed;
                    });

                }
            });
            //@END-PRO
        };

    }

}
